<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-decoration__isRelationSpecial">
            <el-table v-loading="loading" :data="tableData" border style="width: 100%;">
                <el-table-column prop="isBefore" label="以往学期争章修改" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isBefore === '0'">否</el-tag>
                        <el-tag v-else-if="scope.row.isBefore === '1'" type="success">是</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="bindDecoration" label="是否关联特色章" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.bindDecoration === '0'">不关联</el-tag>
                        <el-tag v-else-if="scope.row.bindDecoration === '1'" type="success">争章集赞</el-tag>
                        <el-tag v-else-if="scope.row.bindDecoration === '2'" type="warning">校园特色</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop='isLike' label="评价类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isLike === 0 && scope.row.isStar === 0" type="danger">无</el-tag>
                        <el-tag v-else-if="scope.row.isLike === 1 && scope.row.isStar === 1">点赞、评星</el-tag>
                        <el-tag v-else-if="scope.row.isLike  === 1" type="success">点赞</el-tag>
                        <el-tag v-else-if="scope.row.isStar   === 1" type="warning">评星</el-tag>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)">设置</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 设置弹窗 -->
            <el-dialog :visible.sync="open" title="设置" width="30%">
                <el-form ref="dataForm" label-width="130px">
                    <el-form-item label="以往学期争章修改" prop="isBefore" size="mini">
                        <el-radio-group v-model="dataForm.isBefore">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="关联特色章" prop="bindDecoration">
                        <el-radio-group v-model="dataForm.bindDecoration">
                            <el-radio :label="'0'">不关联</el-radio>
                            <el-radio :label="'1'">争章集赞</el-radio>
                            <el-radio :label="'2'">校园特色</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="点赞评价" prop="evaluateType">
                        <el-radio-group v-model="dataForm.isLike">
                            <el-radio :label="0">关闭</el-radio>
                            <el-radio :label="1">打开</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="评星评价" prop="evaluateType">
                        <el-radio-group v-model="dataForm.isStar">
                            <el-radio :label="0">关闭</el-radio>
                            <el-radio :label="1">打开</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="dataForm.isStar === 1" label="评星设置" prop="evaluationSet">
                        <el-input v-model="dataForm.oneselfStar" placeholder="自评星数量设置" style="width:100px;"></el-input>
                        <el-input v-model="dataForm.familyStar" placeholder="家长评星数量设置"
                            style="width:130px;margin-left:10px"></el-input>
                        <el-input v-model="dataForm.teacherStar" placeholder="教师评星数量设置"
                            style="width:130px;margin-left:10px"></el-input>
                    </el-form-item>
                </el-form>
                <template slot="footer">
                    <el-button @click="open = false">{{ $t('cancel') }}</el-button>
                    <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
                </template>
            </el-dialog>
        </div>
    </el-card>
</template>
<script>
export default ({
  data () {
    return {
      // 表格数据
      tableData: [{ isBefore: '0', bindDecoration: '0', isLike: 1 }],
      loading: false,
      // 弹窗判断
      open: false,
      // 表单数据
      dataForm: {
        isStar: 0,
        isLike: 1,
        isBefore: '',
        bindDecoration: '0',
        oneselfStar: 0,
        familyStar: 0,
        teacherStar: 0,
        id: undefined
      },
      form: {}
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取数据
    getList () {
      this.$http.get('/decoration/medalrule/query').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        console.log(res.data)
        if (res.data == null) {
          this.dataFormSubmitHandle()
          console.log('1')
        } else {
          this.tableData = [res.data]
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          }
          console.log('2')
        }
        console.log(this.tableData)
      }).catch(() => { })
    },
    // 以往学期争章修改（获取信息独立接口）
    getInfo () {
      // 组装参数
      const params = {

      }
      this.$http.get('/classEvaluate/evaluateRule/getChapterConfig', params).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.form = {
          ...this.form,
          ...res.data
        }
        this.dataForm.isBefore=this.form.isContinue
        console.log(this.form)
      }).catch(() => {})
    },
    // 以往学期争章修改（提交的独立接口)
    formSubmitHandle () {
      this.form.isContinue = this.dataForm.isBefore
      this.$http.post(`/classEvaluate/evaluateRule/chapterIsContinue?schoolId=${this.form.schoolId}`, this.form).then(({ data: res }) => {
        if (res.code !== 0) {
          // if (res.code === 10050) {
          //   this.schoolVisible = true
          //   this.getSchoolList()
          // }
          return this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    // 设置按钮
    addOrUpdateHandle (row) {
      console.log(row)
      this.open = true
      this.getInfo()
      // this.dataForm.isBefore = row.isBefore
      // this.dataForm.bindDecoration = row.bindDecoration
      // this.dataForm.id = row.id
      // this.dataForm.oneselfStar = row.oneselfStar
      // this.dataForm.familyStar = row.familyStar
      // this.dataForm.teacherStar = row.teacherStar
      // this.dataForm.isStar = row.isStar
      // this.dataForm.isLike = row.isLike
      console.log(this.dataForm)
    },
    // 确定按钮
    dataFormSubmitHandle () {
      console.log(this.dataForm)
      this.open = false
      this.$http.post('/decoration/medalrule', this.dataForm).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.visible = false
            this.$emit('refreshDataList')
          }
        })
        console.log('调用确定接口')
        this.formSubmitHandle()
        this.getList()
      }).catch(() => { })
    }
  }
})
</script>
<style lang="scss" scoped></style>
